import { patchNote } from '@ax/service';
import { patchNoteInput } from '@ax/service/src/appointment-interface';
import { useMutation } from '@tanstack/react-query';

export function usePatchNoteApi() {
  const patchNoteMutation = useMutation({
    mutationKey: ['patch-note'],
    mutationFn: (data: patchNoteInput) => patchNote(data),
    onError: (error: any) => {
      return error;
    },
  });

  return patchNoteMutation;
}
